/**
 * Mobile presentation for Shopify Forms 1152756. App owns all form behavior.
 * Shadow DOM selectors are private app markup: recheck after Forms updates.
 */
(() => {
  const selector = 'shopify-forms-embed#app-embed-container-1152756';
  const styleId = 'sanola-forms-mobile';
  const declineId = 'sanola-forms-decline';
  // Forms renders the close wrapper beside the content or nested inside it.
  const closeSelector = ':scope > div > [role="button"][aria-label], :scope > div > div > [role="button"][aria-label]';
  const declineLabel = document.getElementById('sanola-forms-mobile-script')?.dataset.declineLabel;
  const mobile = window.matchMedia('(max-width: 749px)');
  const styles = `
    #sanola-forms-decline { display: none !important; }
    @media (max-width: 749px) {
      #app-embed[data-layout="overlay"] [data-testid="btn-form-submit"] { font-weight: 700 !important; }
      #app-embed[data-layout="overlay"] #sanola-forms-decline {
        display: block !important;
        width: fit-content;
        max-width: 100%;
        min-height: 0;
        align-self: center;
        justify-self: center;
        margin: 8px auto;
        padding: 0;
        border: 0;
        background: transparent;
        box-shadow: none;
        color: #fff;
        font: inherit;
        font-size: 12px;
        line-height: 1.5;
        text-align: center;
        text-decoration: underline;
        text-underline-offset: 3px;
        cursor: pointer;
      }
      #app-embed[data-layout="overlay"] #sanola-forms-decline:focus-visible {
        outline: 2px solid #fff;
        outline-offset: 2px;
      }
      #app-embed[data-layout="overlay"]:has(section[role="dialog"][data-sizing="form-wrapper"]) {
        position: fixed !important;
        inset: 0 0 auto !important;
        width: 100% !important;
        /* Keep a layout-viewport backdrop while Safari pans/shrinks the visual viewport. */
        height: max(100lvh, calc(var(--sanola-forms-top, 0px) + var(--sanola-forms-height, 100dvh))) !important;
        overflow: clip !important;
        overscroll-behavior: none;
        background-color: #141414;
        background-image: linear-gradient(rgb(0 0 0 / 15%), rgb(0 0 0 / 15%)), var(--sanola-forms-image, none);
        background-size: cover;
        background-position: center;
        padding: 0 !important;
        transform: none !important;
        rotate: none !important;
        --container-max-w: 100%;
        --container-border-radius: 0px;
        --container-shadow: none;
        --container-background-color: #141414;
        --heading-text-color: #fff;
        --body-text-color: #fff;
        --link-text-color: #fff;
        --form-error-color: #ffb4b4;
        --button-background-color: #fff;
        --button-text-color: #141414;
        --button-close-color: #fff;
      }
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"] {
        position: absolute !important;
        inset: var(--sanola-forms-top, 0px) 0 auto !important;
        box-sizing: border-box !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: none !important;
        height: var(--sanola-forms-height, 100dvh) !important;
        max-height: none !important;
        margin: 0 !important;
        border-radius: 0 !important;
        transform: none !important;
        display: flex !important;
        flex-direction: column !important;
        overflow: clip !important;
        overscroll-behavior: contain;
        background: transparent;
        box-shadow: none !important;
        scroll-padding-block: 60px;
        isolation: isolate;
      }
      #app-embed[data-layout="overlay"]:has(section[role="dialog"][data-sizing="form-wrapper"]) [data-testid="app-router"],
      #app-embed[data-layout="overlay"]:has(section[role="dialog"][data-sizing="form-wrapper"]) #form-container-ref,
      #app-embed[data-layout="overlay"] #form-container-ref > section[role="dialog"] {
        position: static !important;
        overflow: clip !important;
        transform: none !important;
        rotate: none !important;
      }
      #app-embed[data-layout="overlay"] #form-container-ref > section[role="dialog"] > div {
        /* The fullscreen image replaces the app's storefront-dimming backdrop. */
        background: transparent !important;
      }
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"] > div[style*="background-image"] {
        /* The app still owns the image; mirror it onto the non-scrolling backdrop. */
        display: none !important;
      }
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"] > div:is(:has(form), [class*="_gridItemContent_"]) {
        position: relative;
        z-index: 1;
        box-sizing: border-box;
        flex: 0 1 auto;
        min-height: 0;
        max-height: 100%;
        overflow: auto;
        overscroll-behavior: contain;
        margin-top: auto;
        color: #fff;
        background: linear-gradient(to bottom, transparent, rgb(0 0 0 / 80%) 64px, rgb(0 0 0 / 85%));
        width: 100%;
        min-width: 0;
        padding: 80px max(24px, env(safe-area-inset-right)) max(28px, env(safe-area-inset-bottom)) max(24px, env(safe-area-inset-left)) !important;
      }
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"][data-sanola-keyboard] > div:has(form) {
        /* Give the input/button group enough scroll range to reach the center. */
        padding-top: max(80px, calc(var(--sanola-forms-height) / 2)) !important;
        padding-bottom: max(28px, calc(var(--sanola-forms-height) / 2)) !important;
      }
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"] a {
        color: #fff !important;
        text-decoration: underline;
      }
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"] > div:has(> [role="button"][aria-label]),
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"] > div > div:has(> [role="button"][aria-label]) {
        /* Fallback close control for app screens without the decline link. */
        position: absolute !important;
        inset: max(12px, env(safe-area-inset-top)) max(12px, env(safe-area-inset-right)) auto auto !important;
        margin: 0;
        transform: none !important;
        z-index: 2;
      }
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"] > div > [role="button"][aria-label],
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"] > div > div > [role="button"][aria-label] {
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: 44px;
        height: 44px;
        color: #888 !important;
        background: transparent !important;
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
      }
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"] > div > [role="button"][aria-label] svg,
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"] > div > div > [role="button"][aria-label] svg {
        width: 16px;
        height: 16px;
        fill: currentColor;
        filter: none;
      }
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"] > div > [role="button"][aria-label]:focus-visible,
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"] > div > div > [role="button"][aria-label]:focus-visible {
        outline: 2px solid #fff;
        outline-offset: 2px;
      }
      /* Keep Shopify's handler for the decline link. Screens without that link
         retain their native dismissal control (for example, success screens). */
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"]:has(#sanola-forms-decline) > div:has(> [role="button"][aria-label]),
      #app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"]:has(#sanola-forms-decline) > div > div:has(> [role="button"][aria-label]) {
        display: none !important;
      }
      #app-embed[data-layout="overlay"] input { font-size: max(16px, var(--forms-base-font-size)); }
    }
  `;
  let host;
  let root;
  let shadowObserver;
  let hostObserver;
  let retry;
  let lockedScroll;
  let pageLockStyle;
  let keyboardPanel;
  let previousScroll = 0;
  let centerFrame;

  function clearKeyboard() {
    cancelAnimationFrame(centerFrame);
    if (keyboardPanel) {
      keyboardPanel.removeAttribute('data-sanola-keyboard');
      const content = keyboardPanel.querySelector(':scope > div:has(form)');
      if (content) content.scrollTop = previousScroll;
      keyboardPanel = undefined;
    }
  }

  function updateKeyboard(event) {
    const panel = root?.querySelector('section[role="dialog"][data-sizing="form-wrapper"]');
    const content = panel?.querySelector(':scope > div:has(form)');
    const input = panel?.querySelector('[data-testid="field-email"]');
    const submit = panel?.querySelector('[data-testid="btn-form-submit"]');
    const viewport = window.visualViewport;
    const reduced = viewport && Math.abs(viewport.scale - 1) < 0.05 &&
      Math.max(document.documentElement.clientHeight, window.innerHeight) - viewport.height > 100;
    const focused = input && root.activeElement === input;
    if (!panel || !content || !input || !submit || !reduced || (!focused && keyboardPanel !== panel)) {
      clearKeyboard();
      return;
    }
    const opening = keyboardPanel !== panel;
    if (opening) {
      clearKeyboard();
      previousScroll = content.scrollTop;
      keyboardPanel = panel;
      panel.setAttribute('data-sanola-keyboard', '');
    }
    // Recenter on focus/keyboard resize, never on the customer's manual scrolling.
    if (!opening && (!focused || !event || event.type === 'scroll' || event.type === 'focusout')) return;
    cancelAnimationFrame(centerFrame);
    centerFrame = requestAnimationFrame(() => {
      if (keyboardPanel !== panel || !panel.isConnected) return;
      const field = input.getBoundingClientRect();
      const button = submit.getBoundingClientRect();
      const bounds = content.getBoundingClientRect();
      const groupCenter = (field.top + button.bottom) / 2;
      content.scrollTo({ top: content.scrollTop + groupCenter - (bounds.top + content.clientHeight / 2), behavior: 'instant' });
    });
  }

  function setPageLocked(open) {
    if (open && !lockedScroll) {
      lockedScroll = { x: window.scrollX, y: window.scrollY };
      pageLockStyle = document.createElement('style');
      // A separate stylesheet avoids overwriting the theme/app's inline body styles.
      pageLockStyle.textContent = `
        html { overflow: hidden !important; overscroll-behavior: none !important; }
        body { position: fixed !important; top: ${-lockedScroll.y}px !important;
          left: ${-lockedScroll.x}px !important; width: 100% !important;
          overflow: hidden !important; }
      `;
      document.head.append(pageLockStyle);
    } else if (!open && lockedScroll) {
      const position = lockedScroll;
      lockedScroll = undefined;
      pageLockStyle?.remove();
      pageLockStyle = undefined;
      window.scrollTo({ left: position.x, top: position.y, behavior: 'instant' });
    }
  }

  function updateViewport(event) {
    if (!host || !mobile.matches) return;
    const viewport = window.visualViewport;
    host.style.setProperty('--sanola-forms-height', `${viewport?.height ?? window.innerHeight}px`);
    host.style.setProperty('--sanola-forms-top', `${viewport?.offsetTop ?? 0}px`);
    updateKeyboard(event);
  }

  function installStyle() {
    if (!root || !mobile.matches) return;
    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = styles;
      root.append(style);
    }
    const panel = root.querySelector('#app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"]');
    setPageLocked(Boolean(panel) && !host.hidden && host.style.display !== 'none');
    const image = panel?.querySelector(':scope > div[style*="background-image"]');
    const background = image?.style.backgroundImage || 'none';
    if (host.style.getPropertyValue('--sanola-forms-image') !== background) {
      host.style.setProperty('--sanola-forms-image', background);
    }
    updateViewport();
    const submit = panel?.querySelector('[data-testid="btn-form-submit"]');
    const close = panel?.querySelector(closeSelector);
    if (!submit || !close) {
      root.getElementById(declineId)?.remove();
      return;
    }
    if (!declineLabel || root.getElementById(declineId)) return;
    // Delegate to Shopify's close handler so dismissal tracking/focus stay app-owned.
    const decline = document.createElement('button');
    decline.id = declineId;
    decline.type = 'button';
    decline.textContent = declineLabel;
    decline.addEventListener('click', () => panel.querySelector(closeSelector)?.click());
    submit.after(decline);
  }

  function connect() {
    if (!mobile.matches) return;
    const next = document.querySelector(selector);
    if (next === host && root === next?.shadowRoot && root) return;
    clearKeyboard();
    root?.removeEventListener('focusin', updateViewport);
    root?.removeEventListener('focusout', updateViewport);
    shadowObserver?.disconnect();
    hostObserver?.disconnect();
    clearTimeout(retry);
    setPageLocked(false);
    host = next;
    root = host?.shadowRoot;
    if (!root) {
      // A connected custom element can attach its shadow root asynchronously.
      if (host) retry = setTimeout(connect, 250);
      return;
    }
    root.addEventListener('focusin', updateViewport);
    root.addEventListener('focusout', updateViewport);
    updateViewport();
    installStyle();
    hostObserver = new MutationObserver(() => {
      const panel = root?.querySelector('#app-embed[data-layout="overlay"] section[role="dialog"][data-sizing="form-wrapper"]');
      setPageLocked(Boolean(panel) && !host.hidden && host.style.display !== 'none');
    });
    hostObserver.observe(host, { attributes: true, attributeFilter: ['style', 'hidden'] });
    shadowObserver = new MutationObserver(installStyle);
    shadowObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }

  const documentObserver = new MutationObserver(connect);
  function setMode() {
    documentObserver.disconnect();
    clearKeyboard();
    root?.removeEventListener('focusin', updateViewport);
    root?.removeEventListener('focusout', updateViewport);
    shadowObserver?.disconnect();
    hostObserver?.disconnect();
    clearTimeout(retry);
    setPageLocked(false);
    root?.getElementById(declineId)?.remove();
    root = undefined;
    if (mobile.matches) {
      documentObserver.observe(document.body, { childList: true, subtree: true });
      connect();
    } else {
      host?.style.removeProperty('--sanola-forms-height');
      host?.style.removeProperty('--sanola-forms-top');
      host?.style.removeProperty('--sanola-forms-image');
    }
  }
  mobile.addEventListener('change', setMode);
  window.addEventListener('resize', updateViewport, { passive: true });
  window.visualViewport?.addEventListener('resize', updateViewport, { passive: true });
  window.visualViewport?.addEventListener('scroll', updateViewport, { passive: true });
  setMode();
})();
